import type { ReactNode } from 'react';

// The institutional split-screen frame (STR-007 v2.0): a deep-navy brand panel that does the talking,
// and a clean white panel that holds the actual sign-in / session content. Shared by every auth
// surface so the brand panel stays constant while the right side changes.
export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className="auth">
      <aside className="auth__brand">
        {/* Motion hero — a muted, looping background loop (poster paints instantly while it loads).
            aria-hidden + a navy scrim keep the wordmark/headline legible and the panel on-brand. */}
        <video
          className="auth__video"
          autoPlay
          muted
          loop
          playsInline
          poster="/hero/signin-poster.jpg"
          aria-hidden="true"
        >
          <source src="/hero/signin.mp4" type="video/mp4" />
        </video>
        <div className="auth__scrim" aria-hidden="true" />
        <div className="auth__brandtop">
          <span className="auth__wordmark">GGPathOS</span>
          <span className="auth__eyebrow">Deal Analyzer</span>
        </div>
        <div className="auth__hero">
          <h2 className="auth__headline">
            <span className="auth__nowrap">Institutional-grade</span> underwriting.
          </h2>
          <p className="auth__lede">
            Decision discipline at every phase gate — one version of the truth, from underwriting
            through delivery.
          </p>
        </div>
        <div className="auth__tagline">
          <span className="auth__rule" aria-hidden="true" />
          Predictable Excellence &gt; Heroic Recovery
        </div>
      </aside>
      <main className="auth__panel">
        <div className="auth__content">{children}</div>
      </main>
    </div>
  );
}
